// extracted by mini-css-extract-plugin
module.exports = {"blogList":"Blog_blogList__QPaSn","loadMoreBox":"Blog_loadMoreBox__5nm_a","lastArticle":"Blog_lastArticle__V1iOY"};